export default "__VITE_ASSET__7f75a8cc__"